import React, { useState } from "react";
import * as AccountLinkServices from "../../../../services/AccountLinkService";
// import PaginateFilterSelectList from "../../../utils/PaginateFilterSelectList";
import PaginateSelectList from "../../../utils/PaginateSelectList";
import { useTranslation } from "react-i18next";
import { ButtonAction, Icon, ButtonClose } from "./accountLinkList.styled";
import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";
import AccountLineList from "../accountLineList";
import moment from "moment-timezone";
import showDialog from "../../../utils/ShowDialog/ShowDialog";

const AccountLinkListContainer = ({ filters, sortBy, errors }) => {
  const { t } = useTranslation();
  const [forceRefresh, setForceRefresh] = useState(false);
  const dispatch = useDispatch();
  const [itemsSelected, setItemsSelected] = useState(null);

  const columns = [
    {
      header: t("forms.accountLink.table.head.date"),
      accessorKey: "date",
      cell: (info) => moment(info.getValue()).format("DD/MM/YYYY"),
    },
    {
      header: t("forms.accountLink.table.head.period"),
      accessorKey: "period",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.accountLink.table.head.year"),
      accessorKey: "year",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.accountLink.table.head.company"),
      accessorKey: "company",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.accountLink.table.head.order"),
      accessorKey: "order",
      cell: (info) => info.getValue(),
      size: 200,
    },
    {
      header: "",
      accessorKey: "ac",
      size: 250,
      cell: (info) => renderAction(info.row.original),
    },
  ];

  const renderAction = (data) => {
    return (
      <div className="text-center">
        <ButtonAction
          onClick={() => showLine(data)}
          title={t("forms.accountLink.labels.view")}
        >
          <Icon className="fa-solid fa-magnifying-glass"></Icon>
        </ButtonAction>
        <ButtonAction
          onClick={() => showDialogOnDelete(data.uuid)}
          title={t("Eliminar")}
        >
          <Icon className="fa-solid fa-trash-can"></Icon>
        </ButtonAction>
      </div>
    );
  };

  const showDialogOnDeleteMany = () => {
    const uuids = itemsSelected ? Object.keys(itemsSelected) : null;
    if (!uuids || uuids.length <= 0) {
      showDialog(
        t("forms.accountLink.messages.delete.title"),
        t("forms.accountLink.messages.delete.error"),
        "error",
        false,
        "OK"
      );
      return false;
    }

    const okAction = () => {
      AccountLinkServices.deleteManyAccount(uuids).then((result) => {
        setForceRefresh(true);
      });
    };

    const cancelAction = () => {};

    showDialog(
      t("forms.accountLink.dialog.delete.title"),
      t("forms.accountLink.dialog.delete.text2"),
      "question",
      true,
      t("forms.accountLink.dialog.delete.buttonOk"),
      false,
      okAction,
      t("forms.accountLink.dialog.delete.buttonNo"),
      cancelAction
    );
  };

  const showDialogOnDelete = (uuid) => {
    const okAction = () => {
      AccountLinkServices.deleteAccount(uuid).then((result) => {
        setForceRefresh(true);
      });
    };

    const cancelAction = () => {};

    showDialog(
      t("forms.accountLink.dialog.delete.title"),
      t("forms.accountLink.dialog.delete.text"),
      "question",
      true,
      t("forms.accountLink.dialog.delete.buttonOk"),
      false,
      okAction,
      t("forms.accountLink.dialog.delete.buttonNo"),
      cancelAction
    );
  };

  const listData = async (filter) => {
    if (sortBy) {
      filter.sort = sortBy;
    } else {
      // filter.sort = "-code";
    }
    const result = await AccountLinkServices.listFilter(filter);
    return result;
  };

  const hideColumn = {};
  let resize = null;

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  const showLine = async (data) => {
    dispatch(
      show("ModalForm", {
        className: "account-line-modal",
        body: (
          <>
            <div className="row mb-3">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <AccountLineList
                  onCancel={() => handlerClosePopup("ModalForm")}
                  data={data}
                ></AccountLineList>
              </div>
            </div>
          </>
        ),
      })
    );
  };
  // if (deviceSize < SIZES.md) {
  //   hideColumn.itemCode = false;
  //   resize = false;
  // } else if (deviceSize === SIZES.md) {
  //   hideColumn.itemCode = false;
  // }

  return (
    <>
      <div className="row no-margin">
        <div className="col-12 justify-content-end d-flex">
          <button
            type="button"
            className="btn btn-md btn-danger"
            onClick={() => showDialogOnDeleteMany()}
          >
            <i className="fa-solid fa-trash-can"></i> {t("deleteMany")}
          </button>
        </div>
      </div>
      <PaginateSelectList
        refresh={forceRefresh}
        filters={filters}
        columns={columns}
        toList={listData}
        hideColum={hideColumn}
        resize={resize}
        resetRefresh={() => setForceRefresh(false)}
        onChangeSelect={setItemsSelected}
      ></PaginateSelectList>
    </>
  );
};

export default AccountLinkListContainer;
